// Subset of Rma Commodity Codes for LRP from RMA ADM A00420
export const RmaLgmCommodityCodes = {
  CATTLE: '0803',
  SWINE: '0815',
  DAIRY_CATTLE: '0847',
} as const;

export type RmaLgmCommodityCode =
  (typeof RmaLgmCommodityCodes)[keyof typeof RmaLgmCommodityCodes];

export function isRmaLgmCommodityCode(
  commodityCode: string
): commodityCode is RmaLgmCommodityCode {
  return Object.values(RmaLgmCommodityCodes).includes(
    commodityCode as RmaLgmCommodityCode
  );
}

// Subset of RMA Commodity Names for LGM from RMA ADM A00420
export enum RmaLgmCommodityNames {
  CATTLE = 'Cattle',
  SWINE = 'Swine',
  DAIRY_CATTLE = 'Dairy Cattle',
}

/**
 * @deprecated we should really know the commodity code everywhere we know the name
 */
export const RmaLgmCommodityCodeByName = {
  [RmaLgmCommodityNames.CATTLE]: RmaLgmCommodityCodes.CATTLE,
  [RmaLgmCommodityNames.SWINE]: RmaLgmCommodityCodes.SWINE,
  [RmaLgmCommodityNames.DAIRY_CATTLE]: RmaLgmCommodityCodes.DAIRY_CATTLE,
};

export const RmaLgmCommodityNameByCode: Record<
  string, // allow lookup by any rmaCommodityCode
  RmaLgmCommodityNames
> = {
  [RmaLgmCommodityCodes.CATTLE]: RmaLgmCommodityNames.CATTLE,
  [RmaLgmCommodityCodes.SWINE]: RmaLgmCommodityNames.SWINE,
  [RmaLgmCommodityCodes.DAIRY_CATTLE]: RmaLgmCommodityNames.DAIRY_CATTLE,
};
